<template>
  <div class="content assinaturas">
    <h1><span><i class="fas fa-credit-card"></i> Criar Assinatura Por Boleto</span></h1>
    <form>
      <h6><i class="fas fa-list"></i>Dados do Aluno</h6>
      <div class="row">
        <div class="col-12 col-md-6">
          <form-group id="assinaturaNome"  label="Nome">
            <input type="text" class="form-control" id="nome" placeholder=""/>
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="assinaturaEmail"  label="Email">
            <input type="text" class="form-control" id="email" placeholder="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="assinaturaCPF"  label="CPF">
            <input type="text" class="form-control" id="cpf" placeholder="" />
          </form-group>
        </div>
      </div>

      <h6><i class="fas fa-list"></i>Endereço</h6>
      <div class="row">
        <div class="col-12 col-md-6">
          <form-group id="enderecoCep"  label="CEP">
            <input type="text" class="form-control" id="cep" placeholder="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="enderecoRua"  label="Rua">
            <input type="text" class="form-control" id="rua" placeholder="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="enderecoNum"  label="Número">
            <input type="text" class="form-control" id="numero" placeholder="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="enderecoComplemento"  label="Complemento">
            <input type="text" class="form-control" id="complemento" placeholder="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
          <form-group id="enderecoBairro"  label="Bairro">
            <input type="text" class="form-control" id="bairro" placeholder="" />
          </form-group>
        </div>
        <div class="col-12 col-md-6">
        <!-- //   <form-group id="especialidades" label="Especialidade" :field="jaleklinico.especialidade_id || ''"> -->
          <form-group id="estado" label="Estado">
            <!-- // <select class="form-control" v-model="jaleklinico.especialidade_id"> -->
            <select class="form-control">
            <!-- //   <option v-if="especialidades.length == 0" value="">Carregando...</option>
            //   <option v-if="especialidades.length > 0" value="">Selecione</option>
            //   <option v-for="especialidade in especialidades" :value="especialidade.id">{{ especialidade.especialidade }}</option> -->
                <option value="">Selecione</option>
            </select>
          </form-group>
        </div>
        <div class="col-12 col-md-6">
        <!-- //   <form-group id="especialidades" label="Especialidade" :field="jaleklinico.especialidade_id || ''"> -->
          <form-group id="cidade" label="Cidade">
            <!-- // <select class="form-control" v-model="jaleklinico.especialidade_id"> -->
            <select class="form-control">
            <!-- //   <option v-if="especialidades.length == 0" value="">Carregando...</option>
            //   <option v-if="especialidades.length > 0" value="">Selecione</option>
            //   <option v-for="especialidade in especialidades" :value="especialidade.id">{{ especialidade.especialidade }}</option> -->
                <option value="">Selecione</option>
            </select>
          </form-group>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import ListaAssinaturas from '@/modules/Assinaturas/components/ListaAssinaturas'

export default {
  name: 'CriarAssinaturaView',
  components: {},

  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/assinaturas/${tab}`)
    }
  }
}
</script>

<style scoped>

</style>
